import { ref, watch } from 'vue'
import type { Ref } from 'vue'
export function useInvoiceTableFilter(tableData: Ref<Array<any>>, searchArr: Array<any>) {
  // const allData = ref(JSON.parse(JSON.stringify(tableData)));
  const allData = tableData.value

  const filtered = ref(tableData.value)
  const search = ref(searchArr)
  //this is failing on customer field, as some of them are null
  watch(
    () => search.value,
    (newVal, oldVal) => {
      filtered.value = allData.filter((row) => {
        //console.log("..row = " + JSON.stringify(row));
        const searchCustomerName = newVal['customerName'].toString().toLowerCase()
        //console.log('customerName in filter  = ' +row['customerName']);

        const invoiceId = newVal['id'].toString().toLowerCase()
        const projectId = newVal['projectId'].toString().toLowerCase()
        const valueTotal = newVal['value_total'].toString().toLowerCase()
        //customerName in table is related to invoice.customer.invoiceName
        //invoice.customerName is a combined field of customer.name, customer.companyName and customer.invoiceName
        const customerRow = row['customerName'] //.customerName;
        //console.log('customerRpw in filter  = ' + customerRow);
        return (
          row['id'].toString().toLowerCase().includes(invoiceId) &&
          row['projectId'].toString().toLowerCase().includes(projectId) &&
          row['value_total'].toString().toLowerCase().includes(valueTotal) &&
          //row['customerName'].toString().toLowerCase().includes(customerName);
          (customerRow != null ? customerRow.toLowerCase().includes(searchCustomerName) : true)
        )
      })
    },
    { deep: true }
  )

  return { filtered }
}
